<div>
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-9 col-12">
      <!-- Bg -->
      <div class="pt-20 rounded-top bg-picture position-relative">
        <!-- Membership badge at bottom right of bg -->
        <div v-if="membership_name && userHasPaid" class="position-absolute bottom-0 end-0 me-3 mb-2">
          <div class="membership-badge bg-transparent text-primary px-2 py-1 rounded-1 fs-xs">
            <i class="bi bi-patch-check-fill me-2"></i>{{ membership_name }}
          </div>
        </div>
      </div>
      <div class="card rounded-bottom smooth-shadow-sm">
        <div class="d-flex align-items-center justify-content-between
                    pt-4 pb-6 px-4">
          <!-- avatar -->
           <!-- Profile Image Upload Trigger + Avatar -->
<div v-if="profileData" class="d-flex align-items-center">
  <!-- Avatar with Edit Icon -->
  <div
    v-if="profileData.profile_files && profileData.profile_files.length"
    v-for="file in profileData.profile_files"
    :key="file.id"
    class="avatar-xxl me-2 position-relative d-flex justify-content-end align-items-end mt-n10"
    @click="triggerFileUpload"
  >
    <img
      :src="file.file.file_url || require('@/assets/images/user.svg')"
      class="avatar-xxl rounded-circle border border-2"
      alt="Profile"
    />
    <span
    v-if="user_details.user_id === user.user_id"
      class="position-absolute bottom-0 end-0 bg-white rounded-circle p-1 border"
    >
      <i class="bi bi-pencil-fill text-primary"></i>
    </span>
  </div>

  <!-- Default Avatar -->
  <div
    v-else
    class="avatar-xxl rounded-circle border border-2 me-2 d-flex justify-content-center align-items-center text-white mt-n10 position-relative"
    @click="triggerFileUpload"
  >
    <img
      :src="require('@/assets/images/user.svg')"
      class="rounded-circle"
      alt="Default Avatar"
    />
    <span
    v-if="user_details.user_id === user.user_id"
      class="position-absolute bottom-0 end-0 bg-white rounded-circle p-1 border"
    >
      <i class="bi bi-plus text-primary"></i>
    </span>
  </div>

  <!-- Name -->
  <div class="lh-2">
    <h2 class="mb-2 text-secondary">
      {{
        (profileData.user?.first_name || profileData.user?.last_name)
          ? (profileData.user?.first_name || '') + ' ' + (profileData.user?.last_name || '')
          : '\u00A0'
      }}
    </h2>
  </div>

  <!-- Hidden File Input -->
  <input
    ref="fileInput"
    type="file"
    accept="image/*"
    class="d-none"
    @change="onProfilePictureChange"
  />
</div>

<!-- Modal Preview -->
<div
  class="modal fade"
  id="image_preview_modal"
  tabindex="-1"
  aria-labelledby="image_preview_modal_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="image_preview_modal_label">Preview Profile Picture</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <img
          :src="profilePicturePreview"
          alt="Preview"
          class="rounded-circle w-75 h-75"
        />
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="upload_profile_picture">Save</button>
      </div>
    </div>
  </div>
</div>
        </div>





        <!-- nav -->
         <div class="d-flex ">
          <div class="rating-container ms-3 mb-2">
            <div class="d-flex align-items-center d-none">
              <div class="stars me-2 ">
                <input type="radio" id="star5" name="rating" :value="5" v-model="rating" @change="saveRating(5)"
                  :disabled="user.user_id === user_details.user_id" />
                <label :class="{ checked: rating >= 5 }" for="star5" title="5 stars"></label>

                <input type="radio" id="star4" name="rating" :value="4" v-model="rating" @change="saveRating(4)"
                  :disabled="user.user_id === user_details.user_id" />
                <label :class="{ checked: rating >= 4 }" for="star4" title="4 stars"></label>

                <input type="radio" id="star3" name="rating" :value="3" v-model="rating" @change="saveRating(3)"
                  :disabled="user.user_id === user_details.user_id" />
                <label :class="{ checked: rating >= 3 }" for="star3" title="3 stars"></label>

                <input type="radio" id="star2" name="rating" :value="2" v-model="rating" @change="saveRating(2)"
                  :disabled="user.user_id === user_details.user_id" />
                <label :class="{ checked: rating >= 2 }" for="star2" title="2 stars"></label>

                <input type="radio" id="star1" name="rating" :value="1" v-model="rating" @change="saveRating(1)"
                  :disabled="user.user_id === user_details.user_id" />
                <label :class="{ checked: rating >= 1 }" for="star1" title="1 star"></label>
              </div>
              <div class="rating-stats">
                <span class="rating-value fw-bold me-1">{{ rating }}</span>
                <span class="rating-count text-muted text-xs">({{ totalRatings }} rated)</span>
              </div>
            </div>
          </div>

          <ul class="nav nav-lt-tab px-4" id="pills-tab" role="tablist">
            <button v-if="user_details.user_id===user.user_id"
              class="btn btn-primary text-xxs mt-3 mx-2 rounded-5 shadow d-none" data-bs-toggle="modal"
              data-bs-target="#cv_modal">
              <i class="bi bi-eye"></i> View CV
            </button>
            <div v-if="!workbook_domain && user_details.user_id===user.user_id" class="btn-wrapper">
              <router-link v-if="!userHasPaid && !is_cancelled" :to="'/view_membership/'">
                  <button class="btn btn-primary text-xxs rounded-3 btn-sm mt-2 me-2 text-white">
                    <i class="bi bi-patch-check"></i> Join Membership
                  </button>
                </router-link>
                <button v-if="profile_domain || (cbo_domain && user_details.user_role==='admin')"class="btn btn-primary text-xxs rounded-3 btn-sm mt-2 text-white"
                    data-bs-toggle="modal"
                    data-bs-target="#company_profile_modal">
                    <i class="bi bi-briefcase me-1"></i>Create Business Profile
                </button>
            </div>
          </ul>


         </div>


  <div class="mb-3 px-3 d-flex justify-content-between align-items-center">
<div v-if="filtered_profiles.length && profile_domain || (filtered_profiles.length && cbo_domain && user_details.user_role==='admin')"  class="">
    <div class="fw-semibold text-secondary mt-4">Associated Businesses</div>
    <div class="row g-2">
      <div
        v-for="profile in filtered_profiles"
        :key="profile.base_profile?.id"
        class="col-auto"
      >
      <h6><span class="badge bg-primary" @click="open_business_profile(profile)"> {{ profile.profile_name }}</span></h6>
    </div>
  </div>
  </div>

<div class="d-none">
 <div v-if="profileData" class="mb-2 d-flex flex-column align-items-center">

  <div
    class="circular-progress-container bg-light rounded-circle d-flex justify-content-center align-items-center position-relative"
  >
    <svg class="position-absolute circular-progress-svg" viewBox="0 0 120 120">
      <!-- Background Circle -->
      <circle
        cx="60"
        cy="60"
        r="54"
        class="circular-progress-bg"
      />
      <!-- Progress Circle -->
      <circle
        cx="60"
        cy="60"
        r="54"
        class="circular-progress-bar text-primary"

        stroke="currentColor"
        :stroke-dashoffset="circleOffset"
      />
    </svg>

    <div class="position-absolute fw-bold fs-5 text-xxs">
  {{ profileData.completion_percentage + '%'  }}
</div>

  </div>
</div>
<p class="d-none">Completed</p>
</div>

</div>



      </div>


    </div>
    <div v-if="!dwypd_domain && !workbook_domain && user_details.user_id === user.user_id && (userHasPaid || is_cancelled)"
 class="col-lg-9 col-12 mt-2">

    <div class="card border border-light-subtle rounded mt-4">
      <button @click="subscriptionExpanded = !subscriptionExpanded"
        class="btn btn-link text-decoration-none w-100 d-flex justify-content-between align-items-center p-3 text-start text-dark fw-semibold">
        <span>Subscription details</span>
        <i :class="subscriptionExpanded ? 'bi bi-chevron-up' : 'bi bi-chevron-down'" class="text-muted"></i>
      </button>

      <div v-show="subscriptionExpanded" class="border-top px-3 pb-3">
        <div class="row g-3 mt-2">
          <div class="col-md-4">
            <div class="small fw-medium text-secondary mb-1">Plan Type</div>
            <div class="h5 fw-semibold text-primary d-flex align-items-center">
              {{membership_name}}
              <span class="badge bg-secondary bg-opacity-25 text-primary ms-2 small">{{membership_type}}</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="small fw-medium text-secondary mb-1">Status</div>
            <div class="d-flex align-items-center">
              <div :class="[
                  'rounded-circle me-2',
                  is_active ? 'bg-success' : 'bg-danger'
                ]" style="width: 8px; height: 8px;"></div>
              <span :class="['fw-semibold', is_active ? 'text-success' : 'text-danger']">
                {{ is_active ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </div>


          <div class="col-md-4">
            <div class="small fw-medium text-secondary mb-1">Frequency</div>
            <div class="text-dark fw-medium">{{billing_cycle}}</div>
          </div>
        </div>

        <div class="border-top mt-3 pt-3">
          <div class="d-flex justify-content-between align-items-center">
            <div v-if="is_active">
              <div class="small fw-medium text-secondary mb-1">Renews on</div>
              <div class="text-dark fw-medium">{{formatDate(renewal_date)}}</div>
            </div>
            <div>
              <button class="btn btn-primary btn-sm shadow" data-bs-toggle="modal" data-bs-target="#manage-subscription-modal">
                Manage Subscription
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="col-lg-9 col-12 mt-2">
      <div class="bg-light rounded-top shadow-sm px-3 py-2">
        <div class="scrollable-tabs">
          <ul class="nav nav-pills gap-2" id="businessProfileTabs" role="tablist">
            <!-- Static Tabs -->

            <li class="nav-item" role="presentation">
              <button class="nav-link text-xs fw-500 px-4" :class="{ active: activeTab === 'about' }" id="about_tab"
                data-bs-toggle="tab" data-bs-target="#about" type="button" role="tab" aria-controls="about"
                aria-selected="activeTab === 'about'" @click="activeTab = 'posts'">
                About
              </button>
            </li>
            <!-- Dynamic Section Tabs -->
            <li v-for="section in all_section" :key="section.sectionId" class="nav-item" role="presentation">
            <!-- {{section}} -->
              <button class="nav-link text-xs fw-500 px-4"
              :class="{ active: activeTab === ('section_' + section.sectionId) }":id="'section_' + section.sectionId + '_tab'" data-bs-toggle="tab" :data-bs-target="'#section_' + section.sectionId" type="button"
              role="tab" :aria-controls="'section_' + section.sectionId" :aria-selected="activeTab === ('section_' + section.sectionId)"@click="on_dynamic_tab_click(section)">
              <span v-if="section.section?.is_locked">
              <i class="bx bx-lock-alt me-1" title="Locked"></i>
            </span>
              {{ section.section?.name }}
            </button>
          </li>
          </ul>
        </div>
      </div>

      <div class="tab-content row mt-3" id="personal_profile_tabs_content">
        <div class="tab-pane fade" :class="{ 'show active': activeTab === 'about' }" id="about" role="tabpanel"
          aria-labelledby="about_tab">
        <div class="p-4 bg-white rounded-4 shadow-sm border">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="fw-bold text-secondary mb-0 d-flex align-items-center">
              <i class="bi bi-person-fill me-2"></i>Profile Information
              <span v-if="user_details.user_id===user.user_id">
                <a href="#" class="btn border-0 text-primary fs-4 p-1 ms-5 align-middle" data-bs-toggle="modal" data-bs-target="#profile_modal" title="Edit Profile">
                  <i class='bx bxs-edit-alt'></i>
                </a>
              </span>
            </h5>
          </div>
  <!-- Info Item -->
  <div class="bg-light rounded-3 p-2 mb-3">
    <div class="row">
      <div class="col-md-4 text-primary">
        <i class='bx bxs-envelope fs-5 me-2 text-primary'></i><strong>Email:</strong>
      </div>
      <div class="col-md-8">
  {{ profileData.email || '' }}
  <span v-if="user_details.user_id === user.user_id">
    <i v-if="isValidField(profileData.email)" 
      :class="[
         profileData.visibility?.show_email === true
           ? 'bi bi-globe'
           : 'bi bi-lock-fill text-muted',
         'ms-2 cursor-pointer'
       ]"
       @click="open_visibility_modal('show_email')"></i>
  </span>
  <span v-else-if="profileData.visibility?.show_email !== true">
    <i v-if="isValidField(profileData.email)" class="bi bi-lock-fill text-muted"></i>
  </span>
</div>
    </div>
  </div>

        <!-- Phone -->
        <div class="bg-light rounded-3 p-2 mb-3">
          <div class="row">
            <div class="col-md-4 text-primary">
              <i class='bx bxs-phone-call fs-5 me-2 text-primary'></i><strong>Phone:</strong>
            </div>
            <div class="col-md-8">
            {{ profileData.phone_number || '' }}
            <span v-if="user_details.user_id === user.user_id">
              <i v-if="isValidField(profileData.phone_number)"  :class="[profileData.visibility?.show_phone_number === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                @click="open_visibility_modal('show_phone_number')"></i>
            </span>
            <span v-else-if="profileData.visibility?.show_phone_number !== true">
              <i v-if="isValidField(profileData.phone_number)" class="bi bi-lock-fill text-muted"></i>
            </span>
          </div>
          </div>
        </div>

        <!-- Date of Birth -->
        <div class="bg-light rounded-3 p-2 mb-3">
          <div class="row">
            <div class="col-md-4 text-primary">
              <i class='bx bxs-calendar fs-5 me-2 text-primary'></i><strong>Date of Birth:</strong>
            </div>
            <div class="col-md-8">
   {{ is_valid_value(profileData.date_of_birth) ? profileData.date_of_birth : '' }}
  <span v-if="user_details.user_id === user.user_id">
    <i v-if="isValidField(profileData.date_of_birth)" :class="[profileData.visibility?.show_date_of_birth === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
       @click="open_visibility_modal('show_date_of_birth')"></i>
  </span>
  <span v-else-if="profileData.visibility?.show_date_of_birth !== true">
    <i v-if="isValidField(profileData.date_of_birth)" class="bi bi-lock-fill text-muted"></i>
  </span>
</div>
          </div>
        </div>

        <!-- Address -->
        <div class="bg-light rounded-3 p-2 mb-3">
          <div class="row">
            <div class="col-md-4 text-primary">
              <i class='bx bxs-map fs-5 me-2 text-primary'></i><strong>Address:</strong>
            </div>
            <div class="col-md-8">
              <span v-if="user_details.user_id === user.user_id">
                {{ is_valid_value(profileData.location) ? profileData.location : '' }}
                <span v-if="profileData.province">, </span>
                {{ is_valid_value(profileData.province) ? profileData.province : '' }}
                <i v-if="isValidField(profileData.location)" :class="[profileData.visibility?.show_location === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']" @click="open_visibility_modal('show_location')"></i>
              </span>
              <span v-else-if="profileData.visibility?.show_location === true">
                {{ is_valid_value(profileData.location) ? profileData.location : '' }}
                <span v-if="profileData.province">, </span>
                {{ is_valid_value(profileData.province) ? profileData.province : '' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Title & Gender -->
        <div class="bg-light rounded-3 p-2 mb-3">
          <!-- Title Row -->
          <div class="row">
            <div class="col-md-4 text-primary">
              <i class='bx bx-id-card fs-5 me-2 text-primary'></i><strong>Title:</strong>
            </div>
            <div class="col-md-8">
              {{ profileData.title || '' }}
              <span v-if="user_details.user_id === user.user_id">
                <i v-if="isValidField(profileData.title)" :class="[profileData.visibility?.show_title === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                  @click="open_visibility_modal('show_title')"></i>
              </span>
              <span v-else-if="profileData.visibility?.show_title !== true">
                <i v-if="isValidField(profileData.title)" class="bi bi-lock-fill text-muted"></i>
              </span>
            </div>
          </div>
          </div>
        <div class="bg-light rounded-3 p-2 mb-3">

          <!-- Gender Row -->
          <div class="row">
            <div class="col-md-4 text-primary">
              <i class='bx bx-id-card fs-5 me-2 text-primary'></i><strong>Gender:</strong>
            </div>
            <div class="col-md-8">
              {{ profileData.gender || '' }}
              <span v-if="user_details.user_id === user.user_id">
                <i v-if="isValidField(profileData.gender)" :class="[profileData.visibility?.show_gender === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                  @click="open_visibility_modal('show_gender')"></i>
              </span>
              <span v-else-if="profileData.visibility?.show_gender !== true">
                <i v-if="isValidField(profileData.gender)" class="bi bi-lock-fill text-muted"></i>
              </span>
            </div>
          </div>
        </div>

        <!-- Race -->
        <div class="bg-light rounded-3 p-2">
          <div class="row">
            <div class="col-md-4 text-primary">
              <i class='bx bx-group fs-5 me-2 text-primary'></i><strong>Race:</strong>
            </div>
            <div class="col-md-8">
              {{ profileData.race || '' }}
              <span v-if="user_details.user_id === user.user_id">
                <i v-if="isValidField(profileData.race)" :class="[profileData.visibility?.show_race === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                  @click="open_visibility_modal('show_race')"></i>
              </span>
              <span v-else-if="profileData.visibility?.show_race !== true">
                <i v-if="isValidField(profileData.race)" class="bi bi-lock-fill text-muted"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

        </div>
        <div v-for="section in all_section" :key="'section_' + section.sectionId + '_pane'"
        class="tab-pane fade"
        :class="{ 'show active': activeTab === ('section_' + section.sectionId) }"
        :id="'section_' + section.sectionId"
        role="tabpanel"
        :aria-labelledby="'section_' + section.sectionId + '_tab'">
      
      <div class="p-4 bg-white rounded-4 shadow-sm border">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h5 class="fw-bold text-secondary mb-3">
            {{ section.section?.name }}
          </h5>
        </div>

        <div v-if="section.section?.question_sections?.length">
          <div v-for="(qa, index) in paginated_questions(section.section.question_sections)"
              :key="'qa_' + qa.id"
              class="bg-light rounded-3 p-1 mb-3">
            
            <div class="row align-items-center">
              <!-- Question label -->
              <div class="col-md-4 text-primary d-flex align-items-center">
                <i class="bi bi-question-circle-fill fs-5 me-2 text-primary"></i>
                <strong class="mb-0">{{ qa.question?.question || 'Untitled Question' }}</strong>
                <span v-if="qa.question?.is_mandatory" class="text-danger ms-1">*</span>

              </div>

              <!-- Answer content -->
              <div class="col-md-8 text-dark">
                <!-- Creator can edit -->
                <div v-if="String(profileData?.base_profile?.creater.id) === String(user_details.user_id)">
                  <!-- TEXT -->
                  <input v-if="qa.question.question_type.question_type === 'text'"
                        v-model="qa.newAnswer"
                        type="text"
                        class="form-control form-control-sm rounded-5 w-75 mb-2"
                        @input="qa.isChanged = true" />

                  <!-- TEXTAREA -->
                  <textarea v-else-if="qa.question.question_type.question_type === 'textarea'"
                            v-model="qa.newAnswer"
                            class="form-control form-control-sm rounded-5 mb-2"
                            @input="qa.isChanged = true"></textarea>

                  <!-- DATE -->
                  <input v-else-if="qa.question.question_type.question_type === 'date'"
                        v-model="qa.newAnswer"
                        type="date"
                        class="form-control form-control-sm rounded-5 w-25 mb-2"
                        @input="qa.isChanged = true" />

                  <!-- NUMBER -->
                  <input v-else-if="qa.question.question_type.question_type === 'number'"
                        v-model="qa.newAnswer"
                        type="number"
                        class="form-control form-control-sm rounded-5 w-25 mb-2"
                        @input="qa.isChanged = true" />

                  <!-- SELECTION -->
                  <select v-else-if="qa.question.question_type.question_type === 'selection'"
                          v-model="qa.newAnswer"
                          class="form-control form-control-sm rounded-5 w-75 mb-2"
                          @change="qa.isChanged = true">
                    <option v-for="opt in qa.question.options"
                            :key="opt.id"
                            :value="opt.option">
                      {{ opt.option }}
                    </option>
                  </select>

                  <!-- MULTIPLE CHOICE -->
                  <div v-else-if="qa.question.question_type.question_type === 'checkbox'" class="mb-2 d-flex flex-wrap">
                  <div v-for="opt in qa.question.options" :key="opt.id" class="form-check me-3">
                    <input type="checkbox"
                          class="form-check-input"
                          :id="'cb_' + qa.id + '_' + opt.id"
                          :value="opt.option"
                          :checked="qa.newAnswer?.includes(opt.option)"
                          @change="toggleCheckbox(qa, opt.option, $event.target.checked); qa.isChanged = true" />
                    <label class="form-check-label text-xs" :for="'cb_' + qa.id + '_' + opt.id">
                      {{ opt.option }}
                    </label>
                  </div>
                </div>

                  <!-- CHECKBOX -->
              <div v-else-if="qa.question.question_type.question_type === 'checkbox'" class="mb-2">
                <div v-for="opt in qa.question.options" :key="opt.id" class="form-check">
                  <input type="checkbox"
                         class="form-check-input"
                         :id="'cb_' + qa.id + '_' + opt.id"
                         :value="opt.option"
                         :checked="qa.newAnswer?.includes(opt.option)"
                         @change="toggleCheckbox(qa, opt.option, $event.target.checked); qa.isChanged = true" />
                  <label class="form-check-label text-xs"
                         :for="'cb_' + qa.id + '_' + opt.id">
                    {{ opt.option }}
                  </label>
                </div>
              </div>
              <div v-if="qa.validation_error" class="w-100 text-danger small mt-1 ms-2">
                        <i class="bi bi-exclamation-circle-fill me-1"></i>
                        <span>{{ qa.validation_error }}</span></div>
            </div>

            <!-- View mode for other users -->
            <div v-else>
              <div v-if="profileData.answers && profileData.answers.find(ans => ans.question.id === qa.question.id)">
                <div
                v-if="qa.question.question_type.question_type === 'checkbox' && profileData.answers.find(ans => ans.question.id === qa.question.id).answer.trim() !== ''"
              >
                <div
                  v-for="val in profileData.answers.find(ans => ans.question.id === qa.question.id).answer.split(',')"
                  :key="val.trim()"
                  class="form-check form-check-inline"
                >
                  <input type="checkbox" class="form-check-input" checked readonly @click.prevent />
                  <label class="form-check-label">{{ getOptionValue(val.trim(), qa.question.options) || val.trim() }}</label>
                </div>
              </div>
                <div v-else-if="qa.question.question_type.question_type === 'checkbox'" class="text-muted fst-italic">
                  Not submitted
                </div>
                <div v-else>
                  {{
                    profileData.answers.find(ans => ans.question.id === qa.question.id).answer === ''
                      ? 'Not submitted'
                      : getOptionValue(profileData.answers.find(ans => ans.question.id === qa.question.id).answer, qa.question.options)
                        || profileData.answers.find(ans => ans.question.id === qa.question.id).answer
                  }}
                </div>
              </div>
              <div v-else class="text-muted fst-italic">Not submitted</div>
            </div>
          </div>
        </div>
      </div>
              <!-- Pagination Controls -->
<div
  v-if="total_puestion_pages(section.section.question_sections) > 1"
  aria-label="Questions pagination"
  class="mt-3"
>
  <ul class="pagination justify-content-center">
    <li class="page-item me-1" :class="{ disabled: question_page === 1 }">
      <button
        class="page-link bg-primary text-xxs rounded-3 btn-sm mt-2 text-white"
        @click="change_question_page(question_page - 1)"
        :disabled="question_page === 1"
      >
        Previous
      </button>
    </li>

    <li
      class="page-item me-1"
      v-for="page in total_puestion_pages(section.section.question_sections)"
      :key="page"
      :class="{ active: question_page === page }"
    >
      <button
        class="page-link text-xxs rounded-3 btn-sm mt-2"
        @click="change_question_page(page)"
        :class="{
          'bg-secondary text-white': question_page === page,
          'text-primary': question_page !== page
        }"
      >
        {{ page }}
      </button>
    </li>

    <li
      class="page-item ms-1"
      v-if="question_page < total_puestion_pages(section.section.question_sections)"
    >
      <button
        class="page-link bg-primary text-xxs rounded-3 btn-sm mt-2 text-white"
        @click="handle_next_page(section)"
      >
        Next
      </button>
    </li>
  </ul>
</div>
    </div>

    <div v-else class="text-muted fst-italic">No questions available in this section.</div>

    <!-- Show save button only when answers changed -->
    <div v-if="String(profileData?.base_profile?.creater?.id) === String(user_details.user_id)
           && section.section.question_sections.some(q => q.isChanged)
           && (fully_answered_sections[section.section.id] || last_question_page(section))"
        class="d-flex justify-content-end mt-3">
      <button class="btn btn-primary rounded-5 shadow btn-sm" @click="submit_all_answers">
        Save
      </button>
</div>
  </div>
        </div>

    </div>

    </div>

  </div>

  <div class="modal fade" id="profile_modal" tabindex="-1" aria-labelledby="profile_modallabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="profile_modallabel">Edit information</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveProfile" id="profileForm" novalidate class="text-xs">
            <div class="row mb-4">
              <div class="col-lg-6">
                <label for="first_name" ref="first_name" class="form-label fw-500">First Name<span class="text-danger">
                    *</span></label>
                <input type="text" class="form-control text-xs rounded-5" id="first_name" v-model="user.first_name"
                  placeholder="First name" :class="{ 'is-invalid': errors.first_name }">
                <p v-if="errors.first_name" class="text-danger text-xs">{{ errors.first_name }}</p>
              </div>
              <div class="col-lg-6">
                <label for="last_name" ref="last_name" class="form-label fw-500">Last Name<span class="text-danger">
                    *</span></label>
                <input type="text" class="form-control text-xs rounded-5" id="last_name" v-model="user.last_name"
                  placeholder="Last name" :class="{ 'is-invalid': errors.last_name }">
                <p v-if="errors.last_name" class="text-danger text-xs">{{ errors.last_name }}</p>
              </div>
            </div>
            <div class="mb-3">
              <label for="email" ref="email" class="form-label fw-500">Email<span class="text-danger"> *</span></label>
              <input type="email" class="form-control text-xs rounded-5" id="email" v-model="user.email"
                placeholder="Email" :class="{ 'is-invalid': errors.email }">
              <p v-if="errors.email" class="text-danger text-xs">{{ errors.email }}</p>
            </div>

            <div class="mb-3">
              <label for="date_of_birth" ref="date_of_birth" class="form-label fw-500">Date of Birth<span
                  class="text-danger"> *</span></label>
              <input type="date" class="form-control text-xs rounded-5" id="date_of_birth" v-model="user.date_of_birth"
                placeholder="Date of birth" :class="{ 'is-invalid': errors.date_of_birth }">
              <p v-if="errors.date_of_birth" class="text-danger text-xs">{{ errors.date_of_birth }}</p>
            </div>
            <div class="mb-3">
              <label for="phone_number" ref="phone_number" class="form-label fw-500">Phone Number<span
                  class="text-danger"> *</span></label>
              <input type="text" class="form-control text-xs rounded-5" id="phone_number" v-model="user.phone_number"
                placeholder="Phone number" :class="{ 'is-invalid': errors.phone_number }">
              <p v-if="errors.phone_number" class="text-danger text-xs">{{ errors.phone_number }}</p>
            </div>

            <div class="row mb-3">
              <div class="col-lg-6">
                <label for="race_id" ref="race_id" class="form-label fw-500">Race<span class="text-danger">
                    *</span></label>
                <select class="form-control text-xs rounded-5" id="race_id" v-model="race_id"
                  :class="{ 'is-invalid': errors.race_id }">
                  <option class="text-muted" value="">Select Race</option>
                  <option v-for="race in races" :value="race.id" :key="race.id">
                    {{ race.race }}
                  </option>
                </select>
                <p v-if="errors.race_id" class="text-danger text-xs">{{ errors.race_id }}</p>
              </div>
              <div class="col-lg-6">
                <label for="gender_id" ref="gender_id" class="form-label fw-500">Gender<span class="text-danger">
                    *</span></label>
                <select class="form-control text-xs rounded-5" id="gender_id" v-model="user.gender_id"
                  :class="{ 'is-invalid': errors.gender_id }">
                  <option class="text-muted" value="">Select Gender</option>
                  <option v-for="gender in genders" :value="gender.id" :key="gender.id">{{ gender.gender }}</option>
                </select>
                <p v-if="errors.gender_id" class="text-danger text-xs">{{ errors.gender_id }}</p>
              </div>
            </div>
            <div class="mb-3">
              <label for="title" ref="title_id" class="form-label fw-500">Title<span class="text-danger">
                  *</span></label>
              <select class="form-control text-xs rounded-5" id="title" v-model="title_id"
                :class="{ 'is-invalid': errors.title_id }">
                <option class="text-muted" value="">Select Title</option>
                <option v-for="title in titles" :value="title.id" :key="title.id">{{ title.title }}</option>
              </select>
              <p v-if="errors.title_id" class="text-danger text-xs">{{ errors.title_id }}</p>
            </div>
            <div class="mb-3 d-none">
              <label for="street_address" ref="street_address" class="form-label fw-500">Street Address<span
                  class="text-danger"> *</span></label>
              <input type="text" class="form-control text-xs rounded-5" id="street_address"
                v-model="address.street_address" placeholder="Street address"
                :class="{ 'is-invalid': errors.street_address }">
              <p v-if="errors.street_address" class="text-danger text-xs">{{ errors.street_address }}</p>
            </div>
            <div class="row mb-3 d-none">
              <div class="col-lg-6">
                <label for="town" ref="town" class="form-label fw-500">Town<span class="text-danger"> *</span></label>
                <input type="text" class="form-control text-xs rounded-5" id="town" v-model="address.town"
                  placeholder="Town" :class="{ 'is-invalid': errors.town }">
                <p v-if="errors.town" class="text-danger text-xs">{{ errors.town }}</p>
              </div>
              <div class="col-lg-6 d-none">
                <label for="postal_code" ref="postal_code" class="form-label fw-500">Postal Code<span
                    class="text-danger"> *</span></label>
                <input type="text" class="form-control text-xs rounded-5" id="postal_code" v-model="address.postal_code"
                  placeholder="Postal code" :class="{ 'is-invalid': errors.postal_code }">
                <p v-if="errors.postal_code" class="text-danger text-xs">{{ errors.postal_code }}</p>
              </div>
            </div>
            <div class="mb-3">
              <label for="mapSearchBox" class="form-label text-xs fw-500 d-block">Search for Location</label>
              <input id="mapSearchBox" type="text" class="form-control rounded-5 text-xs"
                placeholder="Search location..." v-model="location" />
            </div>

            <div class="row mb-3">
              <div class="col-md-12">
                <label for="province_id" ref="province_id" class="form-label fw-500">Province<span class="text-danger">
                    *</span></label>
                <select class="form-control text-xs rounded-5" id="province_id" v-model="address.province_id"
                  :class="{ 'is-invalid': errors.province_id }">
                  <option class="text-muted" value="">Select Province</option>
                  <option v-for="province in provinces" :value="province.id" :key="province.id">
                    {{ province.province_name }}
                  </option>
                </select>
                <p v-if="errors.province_id" class="text-danger text-xs">{{ errors.province_id }}</p>
              </div>
            </div>
            <div class="text-end">
              <button type="submit" class="btn btn-primary text-white text-xs shadow-sm rounded-5">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>


<teleport to="body">
  <div id="manage-subscription-modal" class="modal fade " tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded-5 shadow">
        <div class="modal-header ">
          <h5 class="modal-title ">Manage Subscription</h5>
          <button class="close-button" type="button" data-bs-dismiss="modal" aria-label="Close">
            <i class="bi bi-x fw-bold"></i>
          </button>
        </div>

        <div class="modal-body">
          <!-- Current Plan Info -->
          <div class="alert bg-transparent bg-opacity-10 border-secondary border-opacity-25 mb-4">
            <div class="d-flex align-items-center mb-2">
              <div class="d-flex align-items-center">
                <div :class="[
                    'rounded-circle me-2',
                    is_active ? 'bg-success' : 'bg-danger'
                  ]" style="width: 12px; height: 12px;"></div>
                <span :class="['fw-semibold', is_active ? 'text-success' : 'text-danger']">
                  {{ membership_name }} - {{ is_active ? 'Active' : 'Inactive' }}
                </span>
              </div>

            </div>
            <div v-if="is_active" class="small text-muted">
              <div>{{billing_cycle}} billing • Renews {{formatDate(renewal_date)}}</div>
              <div>Next charge: R{{membership_price}} on {{formatDate(renewal_date)}}</div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-grid gap-2">
<div v-if="!is_active"
     @click="navigate_to_plans"
     class="btn btn-outline-secondary d-flex justify-content-between align-items-center p-3 text-start text-decoration-none">
  <div class="d-flex align-items-center">
    <i class="bi bi-graph-up text-muted me-3"></i>
    <span class="fw-medium text-dark">View All Plans</span>
    <span class="small text-muted">Compare features and pricing</span>
  </div>
  <button class="btn gradient-btn text-white px-3 py-2 rounded-5 shadow-sm ">
    {{ is_active ? 'Upgrade' : 'Renew' }}
  </button>
</div>


            <button v-if="is_active" class="btn btn-outline-danger d-flex justify-content-between align-items-center p-3 text-start"
              @click="cancel_membership">
              <div class="d-flex align-items-center">
                <i class="bi bi-exclamation-triangle me-3"></i>
                <span class="fw-medium">Cancel Subscription</span>
              </div>
            </button>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-top">
          <div class="text-center w-100 small text-muted">
            Questions about your subscription?
            <a href="#" class="text-warning text-decoration-none">Contact Support</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Visibility Modal -->
<div class="modal fade" id="visibility_modal" tabindex="-1" aria-labelledby="visibilityModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-3 shadow border-0">
      <!-- Header -->
      <div class="modal-header border-bottom-0">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body pb-0">
        <p class="mb-3 text-muted d-flex align-items-center gap-1">
          <i class="bi bi-info-circle"></i>
          Choose who can see this information on your profile.
        </p>

        <div class="form-check mb-3 p-3 rounded border bg-light d-flex align-items-start">
          <input class="form-check-input me-2 mt-1" type="radio" id="public" value="true" v-model="currentVisibility">
          <label class="form-check-label fw-medium" for="public">
            <i class="bx bx-globe me-1"></i> Public
            <div class="small text-muted">Anyone can see this field.</div>
          </label>
        </div>

        <div class="form-check p-3 rounded border bg-light d-flex align-items-start">
          <input class="form-check-input me-2 mt-1" type="radio" id="private" value="false" v-model="currentVisibility">
          <label class="form-check-label fw-medium" for="private">
            <i class="bx bxs-lock-alt me-1"></i> Only Me
            <div class="small text-muted">Only you can see this field.</div>
          </label>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer border-0 pt-0 mt-3">
        <button class="btn btn-secondary btn-sm text-xs shadow-sm d-flex align-items-center gap-1 mt-3" data-bs-dismiss="modal">
         Cancel
        </button>
        <button class="btn btn-primary btn-sm text-xs shadow-sm d-flex align-items-center gap-1 mt-3" @click="save_field_visibility">
           Save
        </button>
      </div>
    </div>
  </div>
</div>

</div>